import "../scss/index.scss";

(() => {
  const body = document.body;
  const btnOpen = document.getElementById(
    "js-menu-toggle",
  ) as HTMLElement | null;
  const btnClose = document.getElementById(
    "js-menu-close",
  ) as HTMLElement | null;
  const menu = document.querySelector<HTMLElement>(".js-menu");

  if (!btnOpen || !menu) return;

  const CLOSE_DELAY = 150;
  const TOGGLE_COOLDOWN_MS = 300;

  const isOpen = () => body.classList.contains("menu-open");

  let cooldownTimer: ReturnType<typeof setTimeout> | null = null;

  const toggleMenu = (open: boolean) => {
    body.classList.toggle("menu-open", open);
    btnOpen.setAttribute("aria-expanded", String(open));
  };

  const tryToggle = (open: boolean) => {
    if (cooldownTimer !== null) return;
    toggleMenu(open);
    cooldownTimer = setTimeout(() => {
      cooldownTimer = null;
    }, TOGGLE_COOLDOWN_MS);
  };

  // open / close
  btnOpen.addEventListener("click", () => tryToggle(!isOpen()));
  btnClose?.addEventListener("click", () => {
    toggleMenu(false);
    if (cooldownTimer !== null) {
      clearTimeout(cooldownTimer);
      cooldownTimer = null;
    }
  });

  // esc
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) toggleMenu(false);
  });

  // focus & outside click guard
  const isAllowedTarget = (target: Node) =>
    menu.contains(target) || btnOpen.contains(target);

  document.addEventListener("focusin", (e) => {
    if (!isOpen()) return;

    const target = e.target as Node;
    if (isAllowedTarget(target)) return;

    menu.querySelector<HTMLElement>("button, a")?.focus();
  });

  document.addEventListener("pointerdown", (e) => {
    if (!isOpen()) return;

    const target = e.target as Node;
    if (!isAllowedTarget(target)) toggleMenu(false);
  });

  // menu link click
  menu.addEventListener("click", (e) => {
    if (!(e.target as HTMLElement | null)?.closest("a")) return;

    window.setTimeout(() => toggleMenu(false), CLOSE_DELAY);
  });

  btnOpen.setAttribute("aria-expanded", "false");
})();

(() => {
  const toggles = document.querySelectorAll<HTMLButtonElement>(
    ".js-nav-submenu-toggle",
  );
  if (!toggles.length) return;

  const closeAll = (except: HTMLButtonElement | null = null) => {
    toggles.forEach((btn) => {
      if (btn === except) return;
      btn.setAttribute("aria-expanded", "false");
      btn.closest(".list-nav-has-submenu")?.classList.remove("is-open");
    });
  };

  if (sessionStorage.getItem("nav-submenu-closed")) {
    closeAll();
    sessionStorage.removeItem("nav-submenu-closed");
  }

  toggles.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const isOpen = btn.getAttribute("aria-expanded") === "true";
      closeAll(isOpen ? btn : null);
      btn.setAttribute("aria-expanded", String(!isOpen));
      btn.closest(".list-nav-has-submenu")?.classList.toggle("is-open", !isOpen);
    });
  });

  document.addEventListener(
    "click",
    (e) => {
      const link = (e.target as HTMLElement | null)?.closest(
        ".list-nav-has-submenu .nav-submenu a",
      );
      if (!link) return;

      sessionStorage.setItem("nav-submenu-closed", "1");
      closeAll();
    },
    true,
  );

  document.addEventListener("click", (e) => {
    const target = e.target as Node;
    if (
      [...toggles].some((btn) => btn.contains(target)) ||
      [...toggles].some((btn) =>
        btn.closest(".list-nav-has-submenu")?.contains(target),
      )
    ) {
      return;
    }
    closeAll();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });
})();
